<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large"
		 type="primary"> 提交 </Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";

    import { getTemplateInfo,submitProcess } from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'

	import {
		formatDate
	} from '@/utils/date'
	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				listLoading: false,
				isDisabled: false,
				formLoading:false
			}
		},
		created() {
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
			
			getTemplate:async function() {
				this.listLoading = true;
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach(async (item) => {
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.listLoading = false;
				});
			},
			getEmployeeRelation() {
				getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {
				this.$forceUpdate()
			},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请部门："+control.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请时间"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var NameOfData = "";
				info.SummaryInfo.push({"Text":"申请时间："+control2.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请原因"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请原因："+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				this.templateData.SummaryList=SummaryList;
				
				
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				this.formLoading = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.formLoading = false;
				});

			}
		},
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
